/* eslint-disable camelcase */
import { LineBaseInterface, LineSectionBaseInterface } from '../lines/types';
import { SectionInterface } from '../sections/types';

/*
 * Action Types
 */
export enum LinesMatrixIntegrationTypes {
  LIST_LINES_MATRIX_INTEGRATION_REQUEST = '@linesMatrixIntegration/LIST_LINES_MATRIX_INTEGRATION_REQUEST',
  LIST_LINES_MATRIX_INTEGRATION_SUCCESS = '@linesMatrixIntegration/LIST_LINES_MATRIX_INTEGRATION_SUCCESS',
  LIST_LINES_MATRIX_INTEGRATION_FAILURE = '@linesMatrixIntegration/LIST_LINES_MATRIX_INTEGRATION_FAILURE',

  GET_LINE_MATRIX_INTEGRATION_REQUEST = '@linesMatrixIntegration/GET_LINE_MATRIX_INTEGRATION_REQUEST',
  GET_LINE_MATRIX_INTEGRATION_SUCCESS = '@linesMatrixIntegration/GET_LINE_MATRIX_INTEGRATION_SUCCESS',
  GET_LINE_MATRIX_INTEGRATION_FAILURE = '@linesMatrixIntegration/GET_LINE_MATRIX_INTEGRATION_FAILURE',

  CREATE_LINE_MATRIX_INTEGRATION_REQUEST = '@linesMatrixIntegration/CREATE_LINE_MATRIX_INTEGRATION_REQUEST',
  CREATE_LINE_MATRIX_INTEGRATION_SUCCESS = '@linesMatrixIntegration/CREATE_LINE_MATRIX_INTEGRATION_SUCCESS',
  CREATE_LINE_MATRIX_INTEGRATION_FAILURE = '@linesMatrixIntegration/CREATE_LINE_MATRIX_INTEGRATION_FAILURE',

  CREATE_LINE_MATRIX_INTEGRATION = '@linesMatrixIntegration/CREATE_LINE_MATRIX_INTEGRATION',

  UPDATE_LINE_MATRIX_INTEGRATION_REQUEST = '@linesMatrixIntegration/UPDATE_LINE_MATRIX_INTEGRATION_REQUEST',
  UPDATE_LINE_MATRIX_INTEGRATION_SUCCESS = '@linesMatrixIntegration/UPDATE_LINE_MATRIX_INTEGRATION_SUCCESS',
  UPDATE_LINE_MATRIX_INTEGRATION_FAILURE = '@linesMatrixIntegration/UPDATE_LINE_MATRIX_INTEGRATION_FAILURE',

  DELETE_LINE_MATRIX_INTEGRATION_REQUEST = '@linesMatrixIntegration/DELETE_LINE_MATRIX_INTEGRATION_REQUEST',
  DELETE_LINE_MATRIX_INTEGRATION_SUCCESS = '@linesMatrixIntegration/DELETE_LINE_MATRIX_INTEGRATION_SUCCESS',
  DELETE_LINE_MATRIX_INTEGRATION_FAILURE = '@linesMatrixIntegration/DELETE_LINE_MATRIX_INTEGRATION_FAILURE',

  SET_SELECTED_START_DATE = '@reports/SELECTED_START_DATE',
  SET_SELECTED_END_DATE = '@reports/SELECTED_END_DATE',
  SELECTED_LINES = '@linesMatrixIntegration/SELECTED_LINES',
}

/*
 * Data types
 */

export interface CreateLineMatrixIntegrationInterface {
  id: string;
  startId: any;
  endId: any;
  value: number;
  time: number;
  status: number;
  lineId: string;
  startLineSection: any;
  endLineSection: any;
  transportOperatorId?: string;
  weekdays?: string[];
  createdAt: string | Date;
  updatedAt: string | Date;
}

export interface ChipsInterface {
  key: number;
  label: string;
  filter: object;
}

export interface LineSectionIntegrationInterface
  extends LineSectionBaseInterface {
  Section: SectionInterface;
  Line: LineBaseInterface;
}
export interface LineTransportOperator {
  cnpj: string;
  createdAt: string;
  id: string;
  name: string;
  photoUrl: string;
  shortName: string;
  tradingName: string;
  type: 0;
  updatedAt: string;
}

export interface LineMatrixIntegrationInterface {
  id: string;
  value: number;
  time: number;
  timeMin: number;
  status: number;
  valueType: number;
  fareType: number;
  lineId: string;
  quantity: number;
  createdAt: string;
  updatedAt: string;
  startId: string;
  endId: string;
  startTime: number;
  endTime: number;
  weekdays?: string[];
  transportOperatorId: string;
  TransportOperator?: LineTransportOperator;
  startLineSection?: LineSectionIntegrationInterface;
  endLineSection?: LineSectionIntegrationInterface;
}

export interface SelectedProfilesInterface {
  id: string;
  name: string;
}

export interface SelectedLinesInterface extends SelectedProfilesInterface {}

/*
 * State type
 */
export interface LinesMatrixIntegrationState {
  readonly linesMatrixIntegrationList: LineMatrixIntegrationInterface[];
  readonly lineMatrixIntegrationData: LineMatrixIntegrationInterface;
  readonly createLineMatrixIntegration: CreateLineMatrixIntegrationInterface[];
  readonly selectedStartDate: Date;
  readonly selectedEndDate: Date;
  readonly selectedLines: SelectedLinesInterface[];
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
